export enum Sizes {
  menuWidth = 300,
}
